import Vue from "vue";

export async function heartbeat() {
  const response = await Vue.prototype.$http.post(`/hb`);

  return response;
}
